import { render, staticRenderFns } from "./edit-form.vue?vue&type=template&id=b117f858&scoped=true&"
import script from "./edit-form.vue?vue&type=script&lang=ts&"
export * from "./edit-form.vue?vue&type=script&lang=ts&"
import style0 from "./edit-form.vue?vue&type=style&index=0&id=b117f858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b117f858",
  null
  
)

export default component.exports